import { isBlockingStatusNotificationDetails } from "@scrile/api-provider/dist/api/BlockingStatusProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";

export default function (notification: Notification): NotificationData | false {
  if (isBlockingStatusNotificationDetails(notification.details)) {
    emitter.emit(EVENTS.BLOCKING_STATUS_CHANGED, notification);
  }
  return false;
}
